export default [
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: { year: 'numeric', month: 'numeric', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
        cols: 6,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Travel Order Status",
        labelName: "name",
        options: [],
        model: null,
        cols: 6,
        reduce: "id",
    },
];